export default __webpack_public_path__ + "static/media/tiago-lins.bde3907e.jpg";